import Client from './Client';

export default class LiveClient {
  constructor() {
    this.client = Client;
  }

  /**
   * 获取课程直播列表
   */
  async pageScheduleLive(data) {
    const res = await this.client.post('/api/live/pageScheduleLive', data);
    return res;
  }

  /**
   * 开启直播间
   */
  async insertCourseLiveRecord(data) {
    const res = await this.client.post('/api/live/insertCourseLiveRecord', data);
    return res;
  }

  /**
   * 开启直播
   */
  async startCourseLiveRecord(data) {
    const res = await this.client.post('/api/live/startCourseLiveRecord', data);
    return res;
  }

  /**
   * 关闭直播
   *
   */
  async closeCourseLiveRecord(data) {
    const res = await this.client.post('/api/live/closeCourseLiveRecord', data);
    return res;
  }

  /**
   * 获取推流地址
   */
  async getPushUrl(data) {
    const res = await this.client.post('/api/live/getPushUrl', data);
    return res;
  }

  /**
   * 获取推流地址 分割
   */
  async getPushUrlSplit(data) {
    const res = await this.client.post('/api/live/getPushUrlSplit', data);
    return res;
  }

  /**
   * 获取播流地址
   */
  async getPullUrl(data) {
    const res = await this.client.post('/api/live/getPullUrl', data);
    return res;
  }

  /**
   * 获取直播视频记录
   */
  async listLiveRecordVideo(data) {
    const res = await this.client.post('/api/live/listLiveRecordVideo', data);
    return res;
  }

  /**
   * 删除视频
   */
  async deleteLiveRecordVideo(data) {
    const res = await this.client.post('/api/live/deleteLiveRecordVideo', data);
    return res;
  }

  /**
   * 直播事件列表
   */
  async listEvent(data) {
    const res = await this.client.post('/api/live/listEvent', data);
    return res;
  }

  /**
   * 修改视频名称
   */
  async updateLiveRecordVideoName(data) {
    const res = await this.client.post('/api/live/updateLiveRecordVideoName', data);
    return res;
  }

  /**
   * 获取直播间信息
   */
  async getLiveRoomInfo(data) {
    const res = await this.client.post('/api/live/getLiveRoomInfo', data);
    return res;
  }

  /**
   * 发送消息
   */
  async sendLiveChatMsg(data) {
    const res = await this.client.post('/api/live/room/sendLiveChatMsg', data);
    return res;
  }

  /**
   * 发送上课通知
   */
  async sendLiveNotice(data) {
    const res = await this.client.post('/api/live/sendLiveNotice', data);
    return res;
  }

  /**
   * 查询可推广的课程
   */
  async listLiveCourseName(data) {
    const res = await this.client.post('/api/course/listLiveCourseName', data);
    return res;
  }

  /**
   * 生成老师推广二维码
   */
  async getTeacherCourseQrCodeUrl(data) {
    const res = await this.client.post('/api/course/getTeacherCourseQrCodeUrl', data);
    return res;
  }

  /**
   * 删除并新增直播视频
   */
  async desertLiveRecordVideoBackend(data) {
    const res = await this.client.post('/api/live/desertLiveRecordVideoBackend', data);
    return res;
  }
}